import React from 'react';
import { Tooltip, Typography } from 'antd';
import styled from '@emotion/styled';

interface ColumnProps {
  title: string;
}

export default React.memo((props: ColumnProps) => {
  const { title } = props;
  return (
    <StyledProductTileContainer>
      <Tooltip placement="topLeft" title={title}>
        <Typography.Text>{title}</Typography.Text>
      </Tooltip>
    </StyledProductTileContainer>
  );
});

const StyledProductTileContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  justify-content: center;
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left;

  .ant-typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
